module.exports = __webpack_public_path__ + "static/media/logo-h.9517c117.svg";